var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "list-group" },
    _vm._l(_vm.items, function (item, index) {
      return _c(
        "a",
        {
          key: item,
          class: [
            { active: _vm.isActive(index) },
            "list-group-item",
            "side-menu-item",
          ],
          on: {
            click: function ($event) {
              return _vm.clicked(index)
            },
          },
        },
        [_vm._v("\n        " + _vm._s(item) + "\n    ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }